import { getActiveUserPackage } from "@/api/user.api";

const FIVE_MINUTES = 5 * 60 * 1000;

const state = {
  emailVerified: false,
  hasActivePackage: false,
};

const mutations = {
  SET_VERIFICATION_STATUS(state, status) {
    state.emailVerified = status;
  },
  SET_PACKAGE_STATUS(state, status) {
    state.hasActivePackage = status;
  },
  SET_LAST_CHECKED_AT(state, timestamp) {
    state.lastCheckedAt = timestamp;
  },
};

const actions = {
  async checkUserStatus({ state, commit }, { force = false } = {}) {
    const now = Date.now();

    if (
      !force &&
      state.lastCheckedAt &&
      now - state.lastCheckedAt < FIVE_MINUTES
    ) {
      return {
        emailVerified: state.emailVerified,
        hasActivePackage: state.hasActivePackage,
      };
    }

    try {
      const response = await getActiveUserPackage();
      if (response.data.errNum === 403 ) {
        commit("SET_VERIFICATION_STATUS", false);
        commit("SET_PACKAGE_STATUS", false);
      } else if (response.data.errNum == 404 ) {
        commit("SET_VERIFICATION_STATUS", true);
        commit("SET_PACKAGE_STATUS", false);
      } else {
        commit("SET_VERIFICATION_STATUS", true);
        commit("SET_PACKAGE_STATUS", true);
      }
    } catch (error) {
      commit("SET_VERIFICATION_STATUS", false);
      commit("SET_PACKAGE_STATUS", false);
    } finally {
      commit("SET_LAST_CHECKED_AT", now);
    }
    
    return {
      emailVerified: state.emailVerified,
      hasActivePackage: state.hasActivePackage,
    };
  },
};

const getters = {
  emailVerified: (state) => state.emailVerified,
  hasActivePackage: (state) => state.hasActivePackage,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
